module.exports = __webpack_public_path__ + "static/media/20170620-_DSC064303.7219f712.jpg";